import React from 'react'
import { components, constants, useTranslation, useServices } from 'cng-web-lib'
import Box from '@material-ui/core/Box'
import AciHighwayManifestApiUrls from 'src/apiUrls/AciHighwayManifestApiUrls'
import FaxCoverSheetFormProperties from './FaxCoverSheetFormProperties'
import { FileForUserGetCurrentLoginId } from 'src/common/FileForUserCommon'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  button: { CngButton },
  form: {
   CngForm
  },
  CngDialog,
} = components

const { FormState } = constants

function FaxCoverSheetDialog(props) {
  const {
    openDialog,
    onClose,
    showNotification
  } = props

  const { initialValues, makeValidationSchema } = FaxCoverSheetFormProperties.formikProps
  const {securedSendRequest } = useServices()
  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()   
  
  function handleEmailCoverSheet(data){
    try {
      securedSendRequest.execute(
        'POST',
        AciHighwayManifestApiUrls.FAX_COVERSHEET,
        data,
        (response) => {
          if (response.status === 200) {
            if (response.data) {
              const errorMessages = response.data.errorMessages

              if (!errorMessages) {
                showNotification(
                  'success',
                  aciHighwayManifestTranslationText.faxCoversheetSuccess
                )
                onClose()
              } else {
                errorMessages.forEach((message) =>
                  showNotification('error', message)
                )
              }
            }
          }
        },
        () => {
          showNotification('error', aciHighwayManifestTranslationText.faxCoversheetError)
        }
      )
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <CngDialog
      dialogContent={
        <CngForm
          formikProps={{
            initialValues: {
              ...(initialValues)
            },
            makeValidationSchema: makeValidationSchema,
            onSubmit: (data) => {
                data.tripNo = openDialog.data && openDialog.data.tripNum
                data.partyId = openDialog.data && openDialog.data.partyId
              data.userId = FileForUserGetCurrentLoginId()
                handleEmailCoverSheet(data)
                onClose()
            }
          }}
          formState={FormState.COMPLETED}
          renderBodySection={(labelMap, shouldHideMap) => (
            <FaxCoverSheetFormProperties.Fields
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
              tripNo={openDialog.data && openDialog.data.tripNum}
            />
          )}
          renderButtonSection={() => (
            <Box display='flex' justifyContent='flex-end'>
              <CngButton color='primary' size='medium' type='submit'>
                {aciHighwayManifestTranslationText.sendButton}
              </CngButton>
            </Box>
          )}
        />
      }
      dialogTitle={aciHighwayManifestTranslationText.faxTitle}
      // fullWidth
      // maxWidth='md'
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          onClose()
        }
      }}
      open={openDialog.open}
      shouldShowCloseButton
    />
  )
}

export default FaxCoverSheetDialog
